import type { GPTModelItem } from "@/api/models"
import type { SessionType } from "@/types"

import { useGPTModelSettings } from "@/hooks/use-gpt-model-settings"

type UseBaseSettingsProps = {
  sessionType: SessionType
}

export function useBaseSettings({ sessionType }: UseBaseSettingsProps) {
  // Use database-backed settings
  const {
    gptModel,
    availableModels,
    shouldStream,
    suggestFollowupQuestions,
    updateGPTModel,
    updateStreamSetting,
    updateFollowupQuestions,
    modelSettingsHydrated,
    isLoading,
  } = useGPTModelSettings(sessionType)

  const handleGptModelChange = (model: GPTModelItem) => {
    // Optimistic update to database
    void updateGPTModel(model)
  }

  // Temperature is not used in the new system, but keeping for compatibility
  const temperature = 0.7

  function handleTemperatureChange() {
    // Temperature handling can be added to database if needed
    // Currently not persisted
  }

  return {
    gptModel,
    availableGptModels: availableModels,
    shouldStream,
    suggestFollowupQuestions,
    handleGptModelChange,
    handleStreamChange: updateStreamSetting,
    handleFollowupQuestionsChange: updateFollowupQuestions,
    modelSettingsHydrated,
    handleTemperatureChange,
    temperature,
    isLoading,
  }
}
